import { Link } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { Modal, Button } from "react-bootstrap";
import "./AllProductCss/AllProduct.css";
import { useProductContext } from "./context/useProductContext";
import useProductHook from "./hooks/useProductHook";

const TableData = ({ tableHeader, dataArr, tableHeaders, tableType }) => {
  const {
    currentPage,
    setCurrentPage,
    fetchAllProductsTableData,
    deleteProduct,
    handleEditButton,
    deleteCategory,
    fetchAllCategories,
  } = useProductHook();
  const [products, setProducts] = useState([
    {
      id: 1,
      image: "images/product-user.png",
      name: "Nike v22",
      description: "Running Shoes",
      sku: "EL-00552",
      orders: 1500,
      price: "130",
      status: "Active",
    },
    {
      id: 2,
      image: "images/product-user.png",
      name: "Nike v22",
      description: "Running Shoes",
      sku: "EL-00552",
      orders: 1500,
      price: "130",
      status: "Blocked",
    },
    {
      id: 3,
      image: "images/product-user.png",
      name: "Nike v22",
      description: "Running Shoes",
      sku: "EL-00552",
      orders: 1500,
      price: "130",
      status: "Active",
    },
    {
      id: 4,
      image: "images/product-user.png",
      name: "Nike v22",
      description: "Running Shoes",
      sku: "EL-00552",
      orders: 1500,
      price: "130",
      status: "Active",
    },
    {
      id: 5,
      image: "images/product-user.png",
      name: "Nike v22",
      description: "Running Shoes",
      sku: "EL-00552",
      orders: 1500,
      price: "130",
      status: "Active",
    },
    {
      id: 6,
      image: "images/product-user.png",
      name: "Nike v22",
      description: "Running Shoes",
      sku: "EL-00552",
      orders: 1500,
      price: "130",
      status: "Active",
    },
    {
      id: 7,
      image: "images/product-user.png",
      name: "Nike v22",
      description: "Running Shoes",
      sku: "EL-00552",
      orders: 1500,
      price: "130",
      status: "Active",
    },
    {
      id: 8,
      image: "images/product-user.png",
      name: "Nike v22",
      description: "Running Shoes",
      sku: "EL-00552",
      orders: 1500,
      price: "130",
      status: "Active",
    },
    {
      id: 9,
      image: "images/product-user.png",
      name: "Nike v22",
      description: "Running Shoes",
      sku: "EL-00552",
      orders: 1500,
      price: "130",
      status: "Active",
    },
    {
      id: 10,
      image: "images/product-user.png",
      name: "Nike v22",
      description: "Running Shoes",
      sku: "EL-00552",
      orders: 1500,
      price: "130",
      status: "Active",
    },
    {
      id: 11,
      image: "images/product-user.png",
      name: "Nike v22",
      description: "Running Shoes",
      sku: "EL-00552",
      orders: 1500,
      price: "130",
      status: "Active",
    },
  ]);

  useEffect(() => {
    if (tableType === "product") {
      fetchAllProductsTableData();
    }

    if (tableType === "category") {
      fetchAllCategories();
    }
  }, [currentPage]);

  const [productsPerPage] = useState(10);
  const [showModal, setShowModal] = useState(false);
  const [productToDelete, setProductToDelete] = useState([]);

  // Pagination
  const indexOfLastProduct = currentPage * productsPerPage;
  const indexOfFirstProduct = indexOfLastProduct - productsPerPage;

  const paginate = (pageNumber) => {
    if (
      pageNumber < 1 ||
      pageNumber > Math.ceil(dataArr.length / productsPerPage)
    )
      return;
    setCurrentPage(pageNumber);
  };

  // Delete product
  const handleDelete = (id) => {
    if (tableType === "product") {
      deleteProduct(id);
    } else if (tableType === "category") {
      deleteCategory(id);
    }
    setShowModal(false);
  };

  const renderImageRow = (row) => {
    switch (tableType) {
      case "product":
        console.log("row in product", row);
        return (
          <div className="product-cell">
            <img
              src={
                row?.product_images[0]?.image_url ||
                "/images/default-product-image.png"
              }
            />
            <div className="product-info">
              <div className="name">{row?.name}</div>
              <div className="description">See Product</div>
            </div>
          </div>
        );
      case "category":
        console.log("category type swith case");
        return (
          <div className="product-cell">
            <img
              src={
                row?.category_images[0]?.image_url ||
                "/images/default-product-image.png"
              }
            />
            <div className="product-info">
              <div className="name">{row.name}</div>
              <div className="description">{row?.description}</div>
            </div>
          </div>
        );
      case "attribute":
      case "productType":
      default:
    }
  };

  return (
    <div className="all_product_page_wepper">
      <div className="top_selling_product_hedding">
        <div className="top_selling_product_hedding_inner">
          <h2>{tableHeader}</h2>
          <Link to="/admin/addProduct">Add {tableType}</Link>
        </div>
        <p>
          All the {tableType} that are Available in the store are listed here
        </p>
      </div>
      <div>
        <div className={`table_wepper  table_${tableType}`}>
          <table className="table table_inner">
            <thead className="custom-thead">
              <tr>
                <th>Name</th>
                {tableHeaders.map((header, index) => (
                  <th key={index}>{header.Header}</th>
                ))}
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {dataArr.length > 0 ? (
                dataArr.map((row, rowIndex) => (
                  <tr key={rowIndex}>
                    <td>{renderImageRow(row)}</td>

                    {/* dtnamic headers */}
                    {tableHeaders.map((header, colIndex) => {
                      console.log("header", header);
                      console.log(
                        "row data",
                        row[header.accessor.toLowerCase()]
                      );

                      if (header.accessor === "status") {
                        return (
                          <td key={colIndex} className="active_dot">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="11"
                              height="11"
                              viewBox="0 0 11 11"
                              fill="none"
                            >
                              <circle
                                cx="5.5"
                                cy="5.5"
                                r="5.5"
                                fill={
                                  row[header?.accessor.toLowerCase()] ===
                                  "Active"
                                    ? "#128C7F"
                                    : "#FF0000"
                                }
                              />
                            </svg>
                            {row[header?.accessor.toLowerCase()]}
                          </td>
                        );
                      } else if (header.accessor === "is_parent") {
                        return (
                          <td key={colIndex}>
                            {row[header?.accessor.toLowerCase()] ? "Yes" : "No"}
                          </td>
                        );
                      } else if (header.accessor === "parent_category_id") {
                        const categoryId = dataArr.find(
                          (item) =>
                            item.id === row[header?.accessor.toLowerCase()]
                        );
                        return (
                          <td key={colIndex}>
                            {categoryId
                              ? categoryId.name
                              : "No Parent Category"}
                          </td>
                        );
                      } else if (header.accessor === "product_status") {
                        console.log("row;;;;;", row);
                        return (
                          <td key={colIndex} className="active_dot">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="11"
                              height="11"
                              viewBox="0 0 11 11"
                              fill="none"
                            >
                              <circle
                                cx="5.5"
                                cy="5.5"
                                r="5.5"
                                fill={
                                  row?.product_status === "active"
                                    ? "#128C7F"
                                    : "#FF0000"
                                }
                              />
                            </svg>
                            {row?.product_status.toUpperCase()}
                          </td>
                        );
                      } else if (header.accessor === "product_price") {
                        return <td key={colIndex}>₹ {row?.price}</td>;
                      } else if (header.accessor === "product_category") {
                        return <td key={colIndex}>{row?.category?.name}</td>;
                      } else if (header.accessor === "product_sku") {
                        return <td key={colIndex}>{row?.unique_sku}</td>;
                      }

                      return (
                        <td key={colIndex}>
                          {row[header?.accessor.toLowerCase()] ||
                            `${header.Header}`}
                        </td>
                      );
                    })}

                    {/* action buttons */}
                    <td className="action_button">
                      {/* Edit Icon */}
                      <span
                        onClick={(e) => {
                          e.preventDefault();
                          handleEditButton(row, tableType);
                        }}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="18"
                          height="18"
                          viewBox="0 0 18 18"
                          fill="none"
                        >
                          <path
                            d="M14.1268 7.75833C13.8448 7.75833 13.6162 7.98695 13.6162 8.26894V15.7578C13.6162 16.2271 13.2344 16.6088 12.7651 16.6088H1.87222C1.40298 16.6088 1.02121 16.2271 1.02121 15.7578V4.8649C1.02121 4.39565 1.40298 4.01389 1.87222 4.01389H9.36111C9.6431 4.01389 9.87172 3.78527 9.87172 3.50328C9.87172 3.22129 9.6431 2.99268 9.36111 2.99268H1.87222C0.839879 2.99268 0 3.83255 0 4.8649V15.7578C0 16.7902 0.839879 17.63 1.87222 17.63H12.7651C13.7975 17.63 14.6374 16.7902 14.6374 15.7578V8.26894C14.6374 7.98695 14.4088 7.75833 14.1268 7.75833Z"
                            fill="black"
                          />
                          <path
                            d="M17.0827 1.51288L16.1199 0.550047C15.6554 0.0855313 14.8996 0.0855313 14.435 0.550047L6.73258 8.2525C6.6613 8.32378 6.61272 8.41457 6.59291 8.51342L6.11148 10.9205C6.07802 11.0879 6.1304 11.2609 6.25115 11.3816C6.34785 11.4783 6.47813 11.5312 6.61218 11.5312C6.6455 11.5312 6.679 11.5279 6.71229 11.5213L9.11932 11.0399C9.21817 11.0201 9.30896 10.9715 9.38024 10.9002L17.0827 3.19778C17.0827 3.19778 17.0828 3.19778 17.0828 3.19774C17.5472 2.73326 17.5472 1.97743 17.0827 1.51288ZM8.76748 10.0688L7.2631 10.3697L7.56402 8.86533L13.8332 2.59601L15.0368 3.79954L8.76748 10.0688ZM16.3606 2.47568L15.7589 3.07744L14.5553 1.87391L15.1571 1.27218C15.2234 1.2058 15.3314 1.20577 15.3978 1.27215L16.3606 2.23498C16.427 2.30132 16.427 2.40933 16.3606 2.47568Z"
                            fill="black"
                          />
                        </svg>
                      </span>

                      {/* Delete Icon */}
                      <span
                        onClick={() => {
                          setShowModal(true);
                          setProductToDelete(row);
                        }}
                        style={{ cursor: "pointer" }}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="19"
                          height="18"
                          viewBox="0 0 19 18"
                          fill="none"
                        >
                          <path
                            d="M15.0625 2.10938H12.4258V1.23047C12.4258 0.551988 11.8738 0 11.1953 0H7.67969C7.00121 0 6.44922 0.551988 6.44922 1.23047V2.10938H3.8125C2.74632 2.10938 1.87891 2.97679 1.87891 4.04297V5.16797C1.87891 5.4592 2.11502 5.69531 2.40625 5.69531H2.99044L4.2008 16.286C4.31246 17.2631 5.13835 18 6.12188 18H12.7531C13.7367 18 14.5625 17.2631 14.6742 16.286L15.8846 5.69531H16.4688C16.76 5.69531 16.9961 5.4592 16.9961 5.16797V4.04297C16.9961 2.97679 16.1287 2.10938 15.0625 2.10938ZM5.24867 16.1662L4.05198 5.69531H14.823L13.6263 16.1662C13.5756 16.6104 13.2002 16.9453 12.7531 16.9453H6.12188C5.67483 16.9453 5.2994 16.6104 5.24867 16.1662Z"
                            fill="#D30A0A"
                          />
                        </svg>
                      </span>
                    </td>
                  </tr>
                ))
              ) : (
                <p style={{ fontWeight: 500, color: "yello" }}>No data found</p>
              )}
            </tbody>
          </table>

          <div>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="1072"
              height="2"
              viewBox="0 0 1072 2"
              fill="none"
            >
              <path d="M0 1H1072" stroke="#E1E1E1" />
            </svg>
            <div className="row align-items-center pagination_weepr">
              {/* Dynamic product count display */}
              <div className="col-lg-4">
                <span>
                  Showing {Math.min(indexOfLastProduct, dataArr.length)} of{" "}
                  {dataArr.length} products
                </span>
              </div>
              <div className="col-lg-8">
                <div>
                  <nav aria-label="...">
                    <ul className="pagination justify-content-end">
                      <li
                        className={`page-item ${
                          currentPage === 1 ? "disabled" : ""
                        }`}
                      >
                        <div
                          className="page-link prev_text"
                          onClick={() => paginate(currentPage - 1)}
                        >
                          Prev
                        </div>
                      </li>
                      {[
                        ...Array(
                          Math.ceil(dataArr.length / productsPerPage)
                        ).keys(),
                      ].map((page) => (
                        <li
                          key={page + 1}
                          className={`page-item ${
                            currentPage === page + 1 ? "active" : ""
                          }`}
                        >
                          <div
                            className="page-link"
                            onClick={() => paginate(page + 1)}
                          >
                            {page + 1}
                          </div>
                        </li>
                      ))}
                      <li
                        className={`page-item ${
                          currentPage ===
                          Math.ceil(dataArr.length / productsPerPage)
                            ? "disabled"
                            : ""
                        }`}
                      >
                        <div
                          className="next_setp"
                          onClick={() => paginate(currentPage + 1)}
                          disabled={
                            currentPage ===
                            Math.ceil(dataArr.length / productsPerPage)
                          }
                        >
                          Next
                        </div>
                      </li>
                    </ul>
                  </nav>
                </div>
              </div>
            </div>
          </div>

          {/* Delete Modal */}
          <Modal show={showModal} onHide={() => setShowModal(false)}>
            <Modal.Header closeButton>
              <Modal.Title>Delete Confirmation</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              Are you sure you want to delete the {tableType}{" "}
              <strong>{productToDelete?.name}</strong>?
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={() => setShowModal(false)}>
                Cancel
              </Button>
              <Button
                variant="danger"
                onClick={() => handleDelete(productToDelete.id)}
              >
                Delete
              </Button>
            </Modal.Footer>
          </Modal>
        </div>
      </div>
    </div>
  );
};

export default TableData;
